/* */ 
"use strict";
var FormatValidators = require('./FormatValidators'),
    Report = require('./Report'),
    Utils = require('./Utils');
var JsonValidators = {
  multipleOf: function(report, schema, json) {
    if (typeof json !== "number") {
      return;
    }
    if (Utils.whatIs(json / schema.multipleOf) !== "integer") {
      report.addError("MULTIPLE_OF", [json, schema.multipleOf], null, schema.description);
    }
  },
  maximum: function(report, schema, json) {
    if (typeof json !== "number") {
      return;
    }
    if (schema.exclusiveMaximum !== true) {
      if (json > schema.maximum) {
        report.addError("MAXIMUM", [json, schema.maximum], null, schema.description);
      }
    } else {
      if (json >= schema.maximum) {
        report.addError("MAXIMUM_EXCLUSIVE", [json, schema.maximum], null, schema.description);
      }
    }
  },
  exclusiveMaximum: function() {},
  minimum: function(report, schema, json) {
    if (typeof json !== "number") {
      return;
    }
    if (schema.exclusiveMinimum !== true) {
      if (json < schema.minimum) {
        report.addError("MINIMUM", [json, schema.minimum], null, schema.description);
      }
    } else {
      if (json <= schema.minimum) {
        report.addError("MINIMUM_EXCLUSIVE", [json, schema.minimum], null, schema.description);
      }
    }
  },
  exclusiveMinimum: function() {},
  maxLength: function(report, schema, json) {
    if (typeof json !== "string") {
      return;
    }
    if (Utils.ucs2decode(json).length > schema.maxLength) {
      report.addError("MAX_LENGTH", [json.length, schema.maxLength], null, schema.description);
    }
  },
  minLength: function(report, schema, json) {
    if (typeof json !== "string") {
      return;
    }
    if (Utils.ucs2decode(json).length < schema.minLength) {
      report.addError("MIN_LENGTH", [json.length, schema.minLength], null, schema.description);
    }
  },
  pattern: function(report, schema, json) {
    if (typeof json !== "string") {
      return;
    }
    if (RegExp(schema.pattern).test(json) === false) {
      report.addError("PATTERN", [schema.pattern, json], null, schema.description);
    }
  },
  additionalItems: function(report, schema, json) {
    if (!Array.isArray(json)) {
      return;
    }
    if (schema.additionalItems === false && Array.isArray(schema.items)) {
      if (json.length > schema.items.length) {
        report.addError("ARRAY_ADDITIONAL_ITEMS", null, null, schema.description);
      }
    }
  },
  items: function() {},
  maxItems: function(report, schema, json) {
    if (!Array.isArray(json)) {
      return;
    }
    if (json.length > schema.maxItems) {
      report.addError("ARRAY_LENGTH_LONG", [json.length, schema.maxItems], null, schema.description);
    }
  },
  minItems: function(report, schema, json) {
    if (!Array.isArray(json)) {
      return;
    }
    if (json.length < schema.minItems) {
      report.addError("ARRAY_LENGTH_SHORT", [json.length, schema.minItems], null, schema.description);
    }
  },
  uniqueItems: function(report, schema, json) {
    if (!Array.isArray(json)) {
      return;
    }
    if (schema.uniqueItems === true) {
      var matches = [];
      if (Utils.isUniqueArray(json, matches) === false) {
        report.addError("ARRAY_UNIQUE", matches, null, schema.description);
      }
    }
  },
  maxProperties: function(report, schema, json) {
    if (Utils.whatIs(json) !== "object") {
      return;
    }
    var keysCount = Object.keys(json).length;
    if (keysCount > schema.maxProperties) {
      report.addError("OBJECT_PROPERTIES_MAXIMUM", [keysCount, schema.maxProperties], null, schema.description);
    }
  },
  minProperties: function(report, schema, json) {
    if (Utils.whatIs(json) !== "object") {
      return;
    }
    var keysCount = Object.keys(json).length;
    if (keysCount < schema.minProperties) {
      report.addError("OBJECT_PROPERTIES_MINIMUM", [keysCount, schema.minProperties], null, schema.description);
    }
  },
  required: function(report, schema, json) {
    if (Utils.whatIs(json) !== "object") {
      return;
    }
    var idx = schema.required.length;
    while (idx--) {
      var requiredPropertyName = schema.required[idx];
      if (json[requiredPropertyName] === undefined) {
        report.addError("OBJECT_MISSING_REQUIRED_PROPERTY", [requiredPropertyName], null, schema.description);
      }
    }
  },
  additionalProperties: function(report, schema, json) {
    if (schema.properties === undefined && schema.patternProperties === undefined) {
      return JsonValidators.properties.call(this, report, schema, json);
    }
  },
  patternProperties: function(report, schema, json) {
    if (schema.properties === undefined) {
      return JsonValidators.properties.call(this, report, schema, json);
    }
  },
  properties: function(report, schema, json) {
    if (Utils.whatIs(json) !== "object") {
      return;
    }
    var properties = schema.properties !== undefined ? schema.properties : {};
    var patternProperties = schema.patternProperties !== undefined ? schema.patternProperties : {};
    if (schema.additionalProperties === false) {
      var s = Object.keys(json);
      var p = Object.keys(properties);
      var pp = Object.keys(patternProperties);
      s = Utils.difference(s, p);
      var idx = pp.length;
      while (idx--) {
        var regExp = RegExp(pp[idx]),
            idx2 = s.length;
        while (idx2--) {
          if (regExp.test(s[idx2]) === true) {
            s.splice(idx2, 1);
          }
        }
      }
      if (s.length > 0) {
        var idx3 = this.options.assumeAdditional.length;
        if (idx3) {
          while (idx3--) {
            var io = s.indexOf(this.options.assumeAdditional[idx3]);
            if (io !== -1) {
              s.splice(io, 1);
            }
          }
        }
        if (s.length > 0) {
          report.addError("OBJECT_ADDITIONAL_PROPERTIES", [s], null, schema.description);
        }
      }
    }
  },
  dependencies: function(report, schema, json) {
    if (Utils.whatIs(json) !== "object") {
      return;
    }
    var keys = Object.keys(schema.dependencies),
        idx = keys.length;
    while (idx--) {
      var dependencyName = keys[idx];
      if (json[dependencyName]) {
        var dependencyDefinition = schema.dependencies[dependencyName];
        if (Utils.whatIs(dependencyDefinition) === "object") {
          exports.validate.call(this, report, dependencyDefinition, json);
        } else {
          var idx2 = dependencyDefinition.length;
          while (idx2--) {
            var requiredPropertyName = dependencyDefinition[idx2];
            if (json[requiredPropertyName] === undefined) {
              report.addError("OBJECT_DEPENDENCY_KEY", [requiredPropertyName, dependencyName], null, schema.description);
            }
          }
        }
      }
    }
  },
  enum: function(report, schema, json) {
    var match = false,
        idx = schema.enum.length;
    while (idx--) {
      if (Utils.areEqual(json, schema.enum[idx])) {
        match = true;
        break;
      }
    }
    if (match === false) {
      report.addError("ENUM_MISMATCH", [json], null, schema.description);
    }
  },
  allOf: function(report, schema, json) {
    var idx = schema.allOf.length;
    while (idx--) {
      var validateResult = exports.validate.call(this, report, schema.allOf[idx], json);
      if (this.options.breakOnFirstError && validateResult === false) {
        break;
      }
    }
  },
  anyOf: function(report, schema, json) {
    var subReports = [],
        passed = false,
        idx = schema.anyOf.length;
    while (idx-- && passed === false) {
      var subReport = new Report(report);
      subReports.push(subReport);
      passed = exports.validate.call(this, subReport, schema.anyOf[idx], json);
    }
    if (passed === false) {
      report.addError("ANY_OF_MISSING", undefined, subReports, schema.description);
    }
  },
  oneOf: function(report, schema, json) {
    var passes = 0,
        subReports = [],
        idx = schema.oneOf.length;
    while (idx--) {
      var subReport = new Report(report, {maxErrors: 1});
      subReports.push(subReport);
      if (exports.validate.call(this, subReport, schema.oneOf[idx], json) === true) {
        passes++;
      }
    }
    if (passes === 0) {
      report.addError("ONE_OF_MISSING", undefined, subReports, schema.description);
    } else if (passes > 1) {
      report.addError("ONE_OF_MULTIPLE", null, null, schema.description);
    }
  },
  not: function(report, schema, json) {
    var subReport = new Report(report);
    if (exports.validate.call(this, subReport, schema.not, json) === true) {
      report.addError("NOT_PASSED", null, null, schema.description);
    }
  },
  definitions: function() {},
  format: function(report, schema, json) {
    var formatValidatorFn = FormatValidators[schema.format];
    if (typeof formatValidatorFn === "function") {
      if (formatValidatorFn.length === 2) {
        report.addAsyncTask(formatValidatorFn, [json], function(result) {
          if (result !== true) {
            report.addError("INVALID_FORMAT", [schema.format, json], null, schema.description);
          }
        });
      } else {
        if (formatValidatorFn.call(this, json) !== true) {
          report.addError("INVALID_FORMAT", [schema.format, json], null, schema.description);
        }
      }
    } else if (this.options.ignoreUnknownFormats !== true) {
      report.addError("UNKNOWN_FORMAT", [schema.format], null, schema.description);
    }
  }
};
var recurseArray = function(report, schema, json) {
  var idx = json.length;
  if (Array.isArray(schema.items)) {
    while (idx--) {
      if (idx < schema.items.length) {
        report.path.push(idx.toString());
        exports.validate.call(this, report, schema.items[idx], json[idx]);
        report.path.pop();
      } else {
        if (typeof schema.additionalItems === "object") {
          report.path.push(idx.toString());
          exports.validate.call(this, report, schema.additionalItems, json[idx]);
          report.path.pop();
        }
      }
    }
  } else if (typeof schema.items === "object") {
    while (idx--) {
      report.path.push(idx.toString());
      exports.validate.call(this, report, schema.items, json[idx]);
      report.path.pop();
    }
  }
};
var recurseObject = function(report, schema, json) {
  var additionalProperties = schema.additionalProperties;
  if (additionalProperties === true || additionalProperties === undefined) {
    additionalProperties = {};
  }
  var p = schema.properties ? Object.keys(schema.properties) : [];
  var pp = schema.patternProperties ? Object.keys(schema.patternProperties) : [];
  var keys = Object.keys(json),
      idx = keys.length;
  while (idx--) {
    var m = keys[idx],
        propertyValue = json[m];
    var s = [];
    if (p.indexOf(m) !== -1) {
      s.push(schema.properties[m]);
    }
    var idx2 = pp.length;
    while (idx2--) {
      var regexString = pp[idx2];
      if (RegExp(regexString).test(m) === true) {
        s.push(schema.patternProperties[regexString]);
      }
    }
    if (s.length === 0 && additionalProperties !== false) {
      s.push(additionalProperties);
    }
    idx2 = s.length;
    while (idx2--) {
      report.path.push(m);
      exports.validate.call(this, report, s[idx2], propertyValue);
      report.path.pop();
    }
  }
};
exports.validate = function(report, schema, json) {
  report.commonErrorMessage = "JSON_OBJECT_VALIDATION_FAILED";
  var to = Utils.whatIs(schema);
  if (to !== "object") {
    report.addError("SCHEMA_NOT_AN_OBJECT", [to], null, schema.description);
    return false;
  }
  var keys = Object.keys(schema);
  if (keys.length === 0) {
    return true;
  }
  var isRoot = false;
  if (!report.rootSchema) {
    report.rootSchema = schema;
    isRoot = true;
  }
  if (schema.$ref !== undefined) {
    var maxRefs = 99;
    while (schema.$ref && maxRefs > 0) {
      if (!schema.__$refResolved) {
        report.addError("REF_UNRESOLVED", [schema.$ref], null, schema.description);
        break;
      } else if (schema.__$refResolved === schema) {
        break;
      } else {
        schema = schema.__$refResolved;
        keys = Object.keys(schema);
      }
      maxRefs--;
    }
    if (maxRefs === 0) {
      throw new Error("Circular dependency by $ref references!");
    }
  }
  var jsonType = Utils.whatIs(json);
  if (schema.type) {
    if (typeof schema.type === "string") {
      if (jsonType !== schema.type && (jsonType !== "integer" || schema.type !== "number")) {
        report.addError("INVALID_TYPE", [schema.type, jsonType], null, schema.description);
        if (this.options.breakOnFirstError) {
          return false;
        }
      }
    } else {
      if (schema.type.indexOf(jsonType) === -1 && (jsonType !== "integer" || schema.type.indexOf("number") === -1)) {
        report.addError("INVALID_TYPE", [schema.type, jsonType], null, schema.description);
        if (this.options.breakOnFirstError) {
          return false;
        }
      }
    }
  }
  var idx = keys.length;
  while (idx--) {
    if (JsonValidators[keys[idx]]) {
      JsonValidators[keys[idx]].call(this, report, schema, json);
      if (report.errors.length && this.options.breakOnFirstError) {
        break;
      }
    }
  }
  if (report.errors.length === 0 || this.options.breakOnFirstError === false) {
    if (jsonType === "array") {
      recurseArray.call(this, report, schema, json);
    } else if (jsonType === "object") {
      recurseObject.call(this, report, schema, json);
    }
  }
  if (typeof this.options.customValidator === "function") {
    this.options.customValidator(report, schema, json);
  }
  if (isRoot) {
    report.rootSchema = undefined;
  }
  return report.errors.length === 0;
};
